import { useCustomColors } from '../hooks/useIframe'
import { useAppStore } from '../stores/useAppStore'
import { useEffect, useState } from 'react'

export default function Statistics() {
  const customColors = useCustomColors()
  const loadStores = useAppStore((s) => s.loadStores)
  const treesPlanted = useAppStore((s) => s.treesPlanted)
  const totalSize = useAppStore((s) => s.totalSize)
  const seedGather = useAppStore((s) => s.seedGather)
  const participants = useAppStore((s) => s.participants)
  const startYear = useAppStore((s) => s.startYear)
  // TEMP: replace with wallet address from context or props if needed
  const [walletAddress] = useState('test-address')

  useEffect(() => {
    loadStores(walletAddress)
    // Only on mount or when wallet changes
  }, [loadStores, walletAddress])
  return (
    <div className="touch-spacing">
      <div className="card">
        <div className="text-center mb-6">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
            Prikaz Statistike
          </h1>
          <p className="text-gray-600 text-sm sm:text-base">
            Najznačajniji podaci prethodnih akcija
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          <div className="card" style={{ backgroundColor: customColors.background.primary }}>
            <div className="text-center">
              <div className="text-2xl font-bold text-green-50 mb-1">{treesPlanted.toLocaleString()}</div>
              <div className="text-sm text-white">Posađenih stabala</div>
            </div>
          </div>
          <div className="card" style={{ backgroundColor: customColors.background.primary }}>
            <div className="text-center">
              <div className="text-2xl font-bold text-green-50 mb-1">{totalSize.toLocaleString()} ha</div>
              <div className="text-sm text-white">Pošumljena površina</div>
            </div>
          </div>
          <div className="card" style={{ backgroundColor: customColors.background.primary }}>
            <div className="text-center">
              <div className="text-2xl font-bold text-green-50 mb-1">{seedGather.toLocaleString()} kg</div>
              <div className="text-sm text-white">Prikupljenog semenskog materijala</div>
            </div>
          </div>
          <div className="card" style={{ backgroundColor: customColors.background.primary }}>
            <div className="text-center">
              <div className="text-2xl font-bold text-green-50 mb-1">{participants.toLocaleString()}</div>
              <div className="text-sm text-white">Broj učesnika</div>
            </div>
          </div>
        </div>

        <div className="space-y-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">
            Detaljnije
          </h2>
          <p className='p-2 rounded-lg mb-4 bg-white'>
          Projekat <span className='text-green-700'>„Zasadi drvo"</span> koji je <span className='text-green-700'>{startYear}.</span> godine pokrenula kompanija WMG (Wireless Media Group), ostvario je prvi zacrtani cilj – istorijskih <span className='text-green-700'>milion</span> posađenih sadnica širom Srbije. Ovaj uspešan projekat najmasovnije sadnje u Srbiji, postao je simbol <span className='text-green-700'>zajedništva</span> i ekološke <span className='text-green-700'>odgovornosti</span>, unapredio je životnu sredinu i inspirisao zajednice širom zemlje da prepoznaju značaj <span className='text-green-700'>zaštite</span> prirodnih resursa.
          </p>
          <div className='md:flex justify-center align-center'>
            <p className='p-2 rounded-lg mb-4 md:mb-0 md:mr-4 flex-1' style={{ backgroundColor: customColors.seed.primary }}>
            Od početka projekta, uz pomoć više od 1.500 građana volontera, partnera i institucija, ozelenjeno je 40 gradova i pošumljeno više od 500 lokacija širom Srbije. Dve divlje deponije su pretvorene u zelene oaze, dok je prikupljeno više od 12 tona semena. Takođe, donirano je 10.000 sadnica osnovnim školama, a vrtićima su omogućeni medni vrtovi i hoteli za pčele. Ovaj projekat je postavio temelje za značajne ekološke promene i nastavio da inspiriše zajednice na očuvanje prirodnih resursa i održivi razvoj.
            </p>
            <p className='p-2 rounded-lg text-green-50 flex-1 mb-12 md:mb-0' style={{ backgroundColor: customColors.background.primary }}>
            Sa milion novih sadnica, Srbija je postala zemlja u kojoj su zelene oaze sada stvarnost i predstavlja inspiraciju za sve da nastave sa očuvanjem prirodnog nasleđa.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
